import React, { useState } from 'react';
import "../styles/trabalheconosco.css";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';

import img1 from "../assets/images/consultorio/image1.jpg";
import img2 from "../assets/images/consultorio/imag2.jpg";
import img3 from "../assets/images/consultorio/image3.jpg";

const TrabalheConosco = () => {
  const images = [img3, img1, img2];
  const [currentIndex, setCurrentIndex] = useState(0);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <section className="work-section" id="work">
      <h2 className="about-title-white">Vamos construir algo juntos?</h2>
      <br></br>
  <div className="container">
    <div className="work-section-content-horizontal">

      {/* Carrossel expandido à esquerda */}
      <div className="work-carousel enhanced-carousel">
        <div className="carousel-slide">
          {images[currentIndex] && (
            <img src={images[currentIndex]} alt={`Slide ${currentIndex + 1}`} className="carousel-image" />
          )}
          <button className="carousel-btn prev" onClick={prevSlide}><FaArrowLeft /></button>
          <button className="carousel-btn next" onClick={nextSlide}><FaArrowRight /></button>
        </div>
      </div>

      {/* Bloco de Texto Convidativo */}
      <div className="trabalhe-info-box modern-text-box">
        
        <p>
          Na <strong>Clínica Psicologia e Saúde</strong>, acreditamos que a escuta transforma vidas.<br />
          Estamos convidando psicólogos(as) que compartilham dessa visão para fazer parte da nossa equipe.
        </p>

        <ul>
          <li>🏡 Ambiente acolhedor e estrutura para atendimentos</li>
          <li>👥 Equipe colaborativa e suporte clínico opcional</li>  
          <li>🗓️ Flexibilidade de agenda e autonomia profissional</li>
        </ul>

        <h3>Requisitos</h3>
        <ul>
          <li>📄 CRP ativo e regularizado</li>
          <li>❤️ Comprometimento ético</li>
          <li>🧠 Escuta empática e <em>sensível</em></li>
          <li>💬 <em><strong>*Sujeito a entrevista com o psicólogo responsável</strong></em></li>
        </ul>

        <a
          href="https://wa.me/5511998835125?text=Olá!%20Tenho%20interesse%20em%20atuar%20como%20psicólogo(a)%20parceiro(a)%20na%20clínica."
          className="trabalhe-button"
          target="_blank"
          rel="noopener noreferrer"
        >
          Quero fazer parte
        </a>
      </div>
    </div>
  </div>
</section>

  );
};

export default TrabalheConosco;
